import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const idfaRequestConfigsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIdfaRequestConfigs: builder.query({
      query: (publisherId) => {
        return {
          url: `/publishers/${publisherId}/sdk/idfa_request_configs`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'IdfaRequestConfig', id: arg }],
    }),
    getDefaultIdfaRequestConfig: builder.query({
      query: () => {
        return {
          url: `/sdk/default_config`
        }},
      providesTags: [{ type: 'IdfaRequestConfig', id: 'Default' }],
    }),
    updateIdfaRequestConfig: builder.mutation({
      query: (idfaRequestConfig) => ({
        url: `/publishers/${idfaRequestConfig.publisher_id}/sdk/idfa_request_configs`,
        method: 'POST',
        body: idfaRequestConfig
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'IdfaRequestConfig', id: arg.publisher_id }],
    }),
    updateDefaultIdfaRequestConfig: builder.mutation({
      query: (idfaRequestConfig) => ({
        url: `/sdk/default_config`,
        method: 'PUT',
        body: idfaRequestConfig
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: [{ type: 'IdfaRequestConfig', id: 'Default' }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetIdfaRequestConfigsQuery,
  useUpdateIdfaRequestConfigMutation,
  useGetDefaultIdfaRequestConfigQuery,
  useUpdateDefaultIdfaRequestConfigMutation
} = idfaRequestConfigsApiSlice
